import { stateArr } from '@/_config';

import type { TValidatedInputFieldProps } from '../third_party/input-field';
import ValidatedInputField from '../third_party/input-field';

const nStateArr = ['', ...stateArr];

function StateInput({
  // state,
  label = 'State',
  // validators = ['required'],
  // errorMessages = ['State is required'],
  ...rest
}: TValidatedInputFieldProps) {
  return (
    <ValidatedInputField
      select
      SelectProps={{
        native: true,
      }}
      label={label}
      {...rest}
    >
      {nStateArr.map((s) => (
        <option key={s} value={s}>
          {s}
        </option>
      ))}
    </ValidatedInputField>
  );
}

export default StateInput;
